// extracted by mini-css-extract-plugin
export default {"shippingStatusContainer":"vD-z","shipmentMessage":"wD-z","shipmentNumber":"xD-z","trackingProgressContainer":"yD-z"};